// supabaseClientFixed.js
// MOCK MODE — Supabase está desactivado, la app es de un solo usuario protegida
// por Cloudflare Access. Este archivo mantiene la API que esperan otros módulos
// (LoginModal, AdminDashboard, etc.) pero no hace requests reales.
//
// Backup del original: supabaseClientFixed.js.original_backup_*

// Helpers para construir chains que no rompen .eq().single() etc.
const buildQueryChain = (resolveData = null, resolveError = null) => {
  const result = { data: resolveData, error: resolveError };
  const chain = {
    select: () => chain,
    insert: () => Promise.resolve(result),
    update: () => chain,
    upsert: () => Promise.resolve(result),
    delete: () => chain,
    eq: () => chain,
    neq: () => chain,
    gt: () => chain,
    gte: () => chain,
    lt: () => chain,
    lte: () => chain,
    in: () => chain,
    is: () => chain,
    like: () => chain,
    ilike: () => chain,
    order: () => chain,
    limit: () => chain,
    range: () => chain,
    single: () => Promise.resolve({ data: null, error: { code: 'PGRST116', message: 'no rows' } }),
    maybeSingle: () => Promise.resolve({ data: null, error: null }),
    then: (resolve) => resolve(result),
  };
  return chain;
};

const mockSubscription = { unsubscribe: () => {} };

const mockSupabase = {
  auth: {
    getSession: async () => ({ data: { session: null }, error: null }),
    getUser: async () => ({ data: { user: null }, error: null }),
    signInWithOAuth: async () => ({ data: null, error: { message: 'Login deshabilitado — app protegida por Cloudflare Access' } }),
    signInWithPassword: async () => ({ data: null, error: { message: 'Login deshabilitado' } }),
    signUp: async () => ({ data: null, error: { message: 'Registro deshabilitado' } }),
    signOut: async () => ({ error: null }),
    resetPasswordForEmail: async () => ({ data: null, error: null }),
    updateUser: async () => ({ data: { user: null }, error: null }),
    onAuthStateChange: (callback) => {
      // Llamamos al callback inmediatamente con sesión nula para que la UI no se quede colgada
      try { callback && callback('INITIAL_SESSION', null); } catch (_) {}
      return { data: { subscription: mockSubscription } };
    },
  },
  from: () => buildQueryChain([], null),
  rpc: async () => ({ data: null, error: null }),
  storage: {
    from: () => ({
      upload: async () => ({ data: null, error: null }),
      download: async () => ({ data: null, error: null }),
      remove: async () => ({ data: null, error: null }),
      getPublicUrl: () => ({ data: { publicUrl: '' } }),
    }),
  },
  channel: () => ({
    on: () => ({ subscribe: () => mockSubscription }),
    subscribe: () => mockSubscription,
    unsubscribe: () => {},
  }),
  removeChannel: () => {},
};

// Listener stub — no hace nada porque no hay eventos de auth reales
export const onAuthStateChange = (callback) => {
  // Disparamos un evento inicial inmediato para que los consumidores no se queden esperando
  if (typeof callback === 'function') {
    setTimeout(() => callback('INITIAL_SESSION', null), 0);
  }
  // Devolver un objeto con la misma forma que el real, por si el consumidor lo usa
  return () => {};
};

export const checkSession = async () => null;

export const getCurrentUser = async () => null;

export const signOut = async () => {
  // Limpieza ligera de cualquier resto de Supabase en localStorage
  try {
    const keys = Object.keys(localStorage);
    keys.forEach((k) => {
      if (k.includes('supabase') || k.includes('sb-') || k.includes('mediexampro_auth')) {
        localStorage.removeItem(k);
      }
    });
  } catch (_) {}
  return { error: null };
};

export const SUPABASE_URL = '';
export const SUPABASE_ANON_KEY = '';

export default mockSupabase;
